import { combineForms } from "react-redux-form";

//Initial states
const errorModel = {
  hasErrors: ""
};

const loginModel = {
  email: "engineer@fourseasonsclimate.com",
  password: "",
  error: null
};

const logoutModel = {
  error: null
};

const signUpModel = {
  name: "",
  email: "",
  password: "",
  passwordConfirm: "",
  siteId: "",
  apiKey: "",
  clientKey: "",
  error: null
};

const profileModel = {
  name: "",
  email: "",
  phone: "",
  position: "",
  notes: "",
  error: null
};

const formsReducer = combineForms(
  {
    errors: errorModel,
    profile: profileModel,
    login: loginModel,
    logout: logoutModel,
    signUp: signUpModel
  },
  "forms"
);

export default formsReducer;



// WEBPACK FOOTER //
// ./src/reducers/formReducer.js